import { BrowserRouter as Router, Route, Routes, NavLink, useLocation } from "react-router-dom";
import DashboardHome from "./pages/DashboardHome";
import UpfrontProfitCalculator from "./pages/UpfrontProfitCalculator";
import Automations from "./pages/Automations";
import "./firebaseConfig";
import { ConfigProvider, Layout, Menu } from "antd";
import React from "react";
import AboutMe from "./pages/AboutMe";
import CommonIssues from "./pages/CommonIssues";
import RecordComparator from "./pages/RecordComparator";
import PrivateRoute from "./pages/PrivateRoute";
import Admin from "./pages/Admin";
import Login from "./pages/Login";
import useInactivityLogout from "./useInactivityLogout";
import PortfolioPage from "./pages/PortfolioPage";
import OFSVisualizer from "./pages/OFSVisualizer";

const { Header, Content } = Layout;
const App = () => {
  const getPageTitle = () => {
    const location = window.location;
    return "Dashboard"
  }
  useInactivityLogout();
  return (
    <ConfigProvider>
      <Router>
        <Layout style={{ minHeight: "100vh", width: "100%" }}>
          <Header style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "#87CEEB",
            padding: "0 20px"
          }}>
            <div style={{ color: "black", fontSize: "20px" }}>{getPageTitle()}</div>
            <Menu
              theme="light"
              mode="horizontal"
              defaultSelectedKeys={["1"]}
              style={{
                backgroundColor: "#87CEEB", // Match header bg
                borderBottom: "none",       // Remove underline line
              }}
            >
              <Menu.Item key="1"><NavLink to="/" >Home</NavLink></Menu.Item>
              <Menu.Item key="2"><NavLink to="/ofsVisualizer">OFS Visualizer</NavLink></Menu.Item>
              <Menu.Item key="3"><NavLink to="/upfrontProfitCalculator">UpfrontProfit Calculator</NavLink></Menu.Item>
              <Menu.Item key="4"><NavLink to="/automations">Automations</NavLink></Menu.Item>
              <Menu.Item key="5"><NavLink to="/commonIssues">Common Issues</NavLink></Menu.Item>
              <Menu.Item key="6"><NavLink to="/recordComparator">Record Comparator</NavLink></Menu.Item>
              <Menu.Item key="7"><NavLink to="/aboutMe">About Me</NavLink></Menu.Item>
              <Menu.Item key="8"><NavLink to="/portfolio">My Portfolio</NavLink></Menu.Item>
            </Menu>
          </Header>
          <Content
            style={{
              padding: "10px",
              width: "100%",
              background: "white",
              borderRadius: "8px",
              overflow: "hidden"
            }}
          >
            <Routes>
              <Route path="/" element={<DashboardHome />} />
              <Route path="/ofsVisualizer" element={<OFSVisualizer />} />
              <Route path="/UpfrontProfitCalculator" element={<UpfrontProfitCalculator />} />
              <Route path="/automations" element={<Automations />} />
              <Route path="/commonIssues" element={<CommonIssues />} />
              <Route path="/recordComparator" element={<RecordComparator />} />
              <Route path="/aboutMe" element={<AboutMe />} />
              <Route path="/login" element={<Login />} />
              <Route path="/portfolio" element={<PortfolioPage />} />
              <Route
                path="/admin"
                element={
                  <PrivateRoute>
                    <Admin />
                  </PrivateRoute>
                }
              />
            </Routes>
          </Content>
        </Layout>

      </Router>
    </ConfigProvider>
  );
};

export default App;
